import { emptyFragment } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import clickOutsideStore from '../../../../ClickOutsideStore';
import { chatMetadataStore } from '../../ChatStores/ChatMetadataStore';
import { chatStore } from '../../ChatStores/ChatStore';
import LicensePicker from './LicensePicker';
import SelectedLicense from './SelectedLicense';

function LicenseSelector() {
  const [selectorActive, setSelectorActive] = useState<boolean>(false);
  const selectorRef = useRef<HTMLDivElement>(null);
  const { state } = chatMetadataStore;

  // We don't want to allow the user to change licenses when the chat is in
  // the middle of a turn in the conversation. This would result in the
  // recommendations being out of sync with the license selected.
  const licenseSelectorEnabled = (): boolean => {
    switch (chatStore.state.kind) {
      case 'ready':
        return true;
      case 'disconnected':
      case 'error':
      case 'streaming':
      case 'streaming-and-receiving-input':
        return false;
    }
  };

  const toggleSelector = () => {
    if (!licenseSelectorEnabled()) {
      return;
    }
    if (selectorActive) {
      setSelectorActive(false);
    } else {
      clickOutsideStore.addListener({
        ref: selectorRef,
        callback: () => setSelectorActive(false),
      });
      setSelectorActive(true);
    }
  };

  switch (state.kind) {
    case 'waiting':
    case 'loading':
      return emptyFragment();
    case 'ready':
      switch (chatMetadataStore.assistantRole) {
        case 'coach':
          return emptyFragment();
        case 'default':
          return (
            <div className="relative" onClick={toggleSelector} ref={selectorRef}>
              <div
                className={clsx(
                  licenseSelectorEnabled() ? 'hover:cursor-pointer' : 'cursor-default',
                  'transform -translate-y-1.5',
                )}
              >
                <SelectedLicense />
              </div>
              <div>
                <LicensePicker
                  active={selectorActive}
                  productLicenses={state.chatMetadataResource
                    .map((resource) => resource.payload.productLicenses)
                    .getOrElseValue([])}
                />
              </div>
            </div>
          );
      }
  }
}

export default observer(LicenseSelector);
